import React from 'react'
import Logo from "../assets/amal-logo-navy.png"

export default function Header({clientName}) {
  return (
    <header className='header'>
      <div>
        <img alt="Amal Logo" src={Logo} className="header-logo" />
      </div>
      <div className="header-" >
        <p className='client-name'>{clientName}</p>
      </div>
    </header>
  )
}
